import React, { Component } from 'react';
import { decodeSpecialSymbols } from '../helpers';
import CKEditor from './ckEditor';
import ckEditorCss from '../styles/ckEditor';
import injectSheet from 'react-jss';

class RichTextEditor extends Component {
    render() {
        const { readOnly, onChange, editorContent, placeholder, classes, onKeyUp, onFocus } = this.props;
        return (
            <CKEditor
                content={decodeSpecialSymbols(editorContent)}
                events={{
                    change: onChange,
                    "onFocus": onFocus
                }}
                config={configObject}
                activeClass={classes.ckDefaultDiv}
            />
        );
    }
}

const configObject = {
    height: "220px",
    removeDialogTabs: 'link:advanced',
    enterMode: 3,
    font_names: 'Sans Serif/arial, helvetica; Serif/times new roman;Fixed Width/monospace; Wide/Arial black;Narrow/Arial narrow; Comic Sans MS; Garamond; Georgia; Tahoma; Trebuchet MS; Verdana;',
    toolbarGroups: [
        { name: 'styles', groups: ['styles'] },
        { name: 'links', groups: ['links'] },
        { name: 'insert', groups: ['insert'] },
        { name: 'basicstyles', groups: ['cleanup', 'basicstyles'] },
        { name: 'colors', groups: ['colors'] },
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'clipboard', groups: ['clipboard', 'undo'] },
        { name: 'editing', groups: ['find', 'selection', 'editing', 'spellchecker'] },
        { name: 'forms', groups: ['forms'] },
        { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
        { name: 'tools', groups: ['tools'] },
        { name: 'others', groups: ['others'] },
        { name: 'about', groups: ['about'] }
    ],
    removePlugins: 'emoji,elementspath,resize,magicline,blockquote,removeformat,image',
    removeButtons: 'About,Preview,ShowBlocks,Styles,FontSize,Iframe,PageBreak,SpecialChar,Smiley,HorizontalRule,Flash,Unlink,Anchor,Language,BidiRtl,BidiLtr,CreateDiv,CopyFormatting,Strike,Subscript,Superscript,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Scayt,SelectAll,Find,Replace,Redo,Undo,Cut,Copy,Paste,PasteFromWord,PasteText,Save,NewPage,Print,Templates',
    allowedContent: {
        'span h1 h2 h3 h4 h5 h6 p div table thead tbody tr td': {
            styles: true
        },
        'table thead tbody tr td':{
            attributes: true,
            classes: { tip: true },
            styles: true
        },
        img: {
            attributes: [ '!src', 'alt', 'width', 'height' ],
            classes: { tip: true }
        },
        a: {
            attributes: 'href',
            styles: true
        },
        'div h1 h2 h3 h4 h5 h6 p': {
            attributes: true
        },
        'strong em u': {}
    }
};

RichTextEditor = injectSheet(ckEditorCss)(RichTextEditor);
export default RichTextEditor;
export {
    RichTextEditor
};

//config.removeButtons = 'Source,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Form,HiddenField,ImageButton,Button,Select,Textarea,TextField,Strike,Subscript,Superscript,RemoveFormat,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Unlink,Anchor,Image,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,About,Replace,ShowBlocks';